import { site } from '@yola/ws-sdk';
import getTemplateBuildSlugTrait from '../helpers/get-template-build-slug-trait';
import track from '../track';

const trackEvent = (event, traits = {}) => {
  track(event, {
    siteId: site.accessors.getSiteId(),
    templateBuildSlug: getTemplateBuildSlugTrait(),
    ...traits,
  });
};

export default trackEvent;
